import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ContentLabelField, Grid, Toggle } from '@hopskipdrive/react-components';

export interface LegacyNotificationsProps {
  sendNoShowNotifications?: string;
  messagingUpdatesRidersCaregivers?: string;
  editMode: boolean;
}

const LegacyNotifications: FC<LegacyNotificationsProps> = ({
  sendNoShowNotifications,
  messagingUpdatesRidersCaregivers,
  editMode,
}) => {
  const { control } = useFormContext();

  return (
    <Grid container>
      <Grid item xs={6}>
        <ContentLabelField
          id="sendNoShowNotifications"
          title="Send rider no show SMS alerts to Trip Organizers"
          description={sendNoShowNotifications}
          editMode={editMode}
          editView={
            <Controller
              render={({ field: { value, onChange, onBlur } }) => (
                <Toggle value={value} onBlur={onBlur} onChange={onChange} exclusive>
                  <Toggle.Option value="Yes" key="Yes">
                    Yes
                  </Toggle.Option>
                  <Toggle.Option value="No" key="No">
                    No
                  </Toggle.Option>
                </Toggle>
              )}
              name="sendNoShowNotifications"
              control={control}
            />
          }
        />

        <ContentLabelField
          id="sendConfirmationSms"
          title="Send confirmation, update, and cancellation SMS alerts to Caregivers and Riders"
          description={messagingUpdatesRidersCaregivers}
          editMode={editMode}
          editView={
            <Controller
              render={({ field: { value, onChange, onBlur } }) => (
                <Toggle value={value} onBlur={onBlur} onChange={onChange} exclusive>
                  <Toggle.Option value="Yes" key="Yes">
                    Yes
                  </Toggle.Option>
                  <Toggle.Option value="No" key="No">
                    No
                  </Toggle.Option>
                </Toggle>
              )}
              name="messagingUpdatesRidersCaregivers"
              control={control}
            />
          }
        />
      </Grid>
    </Grid>
  );
};

export default LegacyNotifications;
